import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

// Generate a session ID for the user's visit
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('analytics_session_id');
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substring(2)}`;
    sessionStorage.setItem('analytics_session_id', sessionId);
  }
  return sessionId;
};

export const usePageViewTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const trackPageView = async () => {
      const fullUrl = window.location.origin + location.pathname + location.search;
      const pageTitle = document.title;
      const pagePath = location.pathname + location.search;
      
      try {
        // Push page_view event to dataLayer for GTM
        // GTM will handle sending to GA4 - no direct GA4 calls
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'page_view',
            page_path: pagePath,
            page_title: pageTitle,
            page_location: fullUrl,
          });
        }

        // Get anonymized location data (country only, no city for privacy)
        let country = null;
        
        try {
          const geoResponse = await fetch('https://ipapi.co/json/');
          if (geoResponse.ok) {
            const geoData = await geoResponse.json();
            country = geoData.country_name;
          }
        } catch (error) {
          console.log('Could not fetch location data:', error);
        }

        // Store minimal analytics data in Supabase
        const { error } = await supabase.from('page_views').insert({
          page_path: location.pathname,
          page_title: pageTitle,
          referrer: document.referrer || null,
          user_agent: null,
          country,
          city: null,
          session_id: getSessionId(),
        });

        if (error) {
          console.error('Error tracking page view:', error);
        }
      } catch (error) {
        console.error('Error in page view tracking:', error);
      }
    };

    // Small delay to ensure page title has updated
    const timeoutId = setTimeout(trackPageView, 100);
    return () => clearTimeout(timeoutId);
  }, [location.pathname, location.search]); // Re-run on route OR query param changes
};
